export class ApplicationDetailedLifecycle {
  public static CARRIER_AUDIT_REVIEW = 'CARRIER_AUDIT_REVIEW';
  public static COMPLETED_ACTIVATED = 'COMPLETED_ACTIVATED';
  public static COMPLETED_CLR = 'COMPLETED_CLR';
  public static COMPLETED_INSTANT_DECISION = 'COMPLETED_INSTANT_DECISION';
  public static COMPLETED_PIA = 'COMPLETED_PIA';
  public static COMPLETED_REINSTATEMENT = 'COMPLETED_REINSTATEMENT';
  public static COMPLETED_RUW = 'COMPLETED_RUW';
  public static COMPLETED_PLAN_F = 'COMPLETED_PLAN_F';
  public static FINAL_AUDIT_REVIEW = 'FINAL_AUDIT_REVIEW';
  public static HOLDING_FOR_RESCISSION = 'HOLDING_FOR_RESCISSION';
  public static PIA = 'PIA';
  public static PIA_EVIDENCE_HOLD = 'PIA_EVIDENCE_HOLD';
  public static PIA_PEER_REVIEW = 'PIA_PEER_REVIEW';
  public static PIA_POST_DECISION = 'PIA_POST_DECISION';
  public static PLAN_F = 'PLAN_F';
  public static PLAN_F_AUDIT_PEER_REVIEW = 'PLAN_F_AUDIT_PEER_REVIEW';
  public static PLAN_F_POST_DECISION = 'PLAN_F_POST_DECISION';
  public static REINSTATEMENT = 'REINSTATEMENT';
  public static REINSTATEMENT_PEER_REVIEW = 'REINSTATEMENT_PEER_REVIEW';
  public static REINSTATEMENT_POST_DECISION = 'REINSTATEMENT_POST_DECISION';
  public static RUW = 'RUW';
  public static RUW_PEER_REVIEW = 'RUW_PEER_REVIEW';
  public static RUW_POST_DECISION = 'RUW_POST_DECISION';
  public static INVESTIGATION = 'INVESTIGATION';
  public static COMPLETED_INVESTIGATION = 'COMPLETED_INVESTIGATION';
}

/**
 * Color mapping for detailed lifecycle states
 */
export const DetailedLifecycleColorMap: Record<string, string> = {
  RUW: 'DodgerBlue',
  RUW_PEER_REVIEW: 'SteelBlue',
  RUW_POST_DECISION: 'DeepSkyBlue',
  COMPLETED_RUW: 'MediumSeaGreen',
  RECONSIDERATION: 'MediumSeaGreen',
  RECONSIDERATION_PEER_REVIEW: 'ForestGreen',
  RECONSIDERATION_POST_DECISION: 'MediumAquamarine',
  COMPLETED_RECONSIDERATION: 'MediumSeaGreen',
  PIA: 'DarkOrange',
  COMPLETED_PIA: 'MediumSeaGreen',
  INTERNAL_AUDIT: 'Chocolate',
  COMPLETED_INTERNAL_AUDIT: 'Peru',
  COMPLETED_CLR: 'MediumSeaGreen',
  PLAN_F: 'LightSeaGreen',
  COMPLETED_PLAN_F: 'Turquoise',
  REINSTATEMENT: 'DarkOrchid',
  REINSTATEMENT_POST_DECISION: 'Orchid',
  COMPLETED_REINSTATEMENT: 'MediumSeaGreen',
  FRAUD_INVESTIGATION: 'Brown',
  CARRIER_AUDIT_REVIEW: 'DodgerBlue',
  FINAL_AUDIT_REVIEW: 'DarkBlue',
  HOLDING_FOR_RESCISSION: 'Coral',
  REINSTATEMENT_PEER_REVIEW: 'DarkBlue',
  PIA_POST_DECISION: 'DarkGreen',
  PIA_PEER_REVIEW: 'Orange',
  COMPLETED_INSTANT_DECISION: 'MediumSeaGreen',
  COMPLETED_ACTIVATED: 'MediumSeaGreen',
  PLAN_F_POST_DECISION: 'DarkGreen',
  PLAN_F_AUDIT_PEER_REVIEW: 'DarkBlue',
  INVESTIGATION: 'DarkViolet',
  COMPLETED_INVESTIGATION: 'MediumSeaGreen',
};
